<div nz-row [nzGutter]="['0','0']" class="import">
  <div nz-col nzSm="24" nzMd="24">



    <nz-divider nzText="Thông tin cá nhân" nzOrientation="left" nzPlain></nz-divider>

    <div nz-row [nzGutter]="[24,24]" style="padding: 10px;">
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.madinhdanh" [ngModelOptions]="{standalone: true}" nz-checkbox>Mã
            định danh</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.ngaysinh" [ngModelOptions]="{standalone: true}" nz-checkbox>Ngày
            sinh</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.dantoc" [ngModelOptions]="{standalone: true}" nz-checkbox>Dân
            tộc</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.sdt" [ngModelOptions]="{standalone: true}" nz-checkbox>SĐT</label>
        </nz-form-item>
      </div>

      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.hoten" [ngModelOptions]="{standalone: true}" nz-checkbox>Họ
            tên</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.namnhaphoc" [ngModelOptions]="{standalone: true}" nz-checkbox>Năm
            nhập học</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.tongiao" [ngModelOptions]="{standalone: true}" nz-checkbox>Tôn
            giáo</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.email" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Email</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.gioitinh" [ngModelOptions]="{standalone: true}" nz-checkbox>Giới
            tính</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.noisinh" [ngModelOptions]="{standalone: true}" nz-checkbox>Nơi
            sinh</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.cmnd" [ngModelOptions]="{standalone: true}" nz-checkbox>CMND</label>
        </nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.noiohiennay" [ngModelOptions]="{standalone: true}" nz-checkbox>Nơi ở
            hiện nay</label></nz-form-item>
      </div>
    </div>

    <nz-divider nzText="Thông tin gia đình" nzOrientation="left" nzPlain></nz-divider>

    <div nz-row [nzGutter]="[24,24]" style="padding: 10px;">
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.hotencha" [ngModelOptions]="{standalone: true}" nz-checkbox>Họ tên
            cha</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.namsinhcha" [ngModelOptions]="{standalone: true}" nz-checkbox>Năm
            sinh cha</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.nghenghiepcha" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Nghề nghiệp cha</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.sdtcha" [ngModelOptions]="{standalone: true}" nz-checkbox>SĐT
            Cha</label></nz-form-item>
      </div>

      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.hotenme" [ngModelOptions]="{standalone: true}" nz-checkbox>Họ tên
            mẹ</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.namsinhme" [ngModelOptions]="{standalone: true}" nz-checkbox>Năm
            sinh mẹ</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.nghenghiepme" [ngModelOptions]="{standalone: true}" nz-checkbox>Nghề
            nghiệp mẹ</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.sdtme" [ngModelOptions]="{standalone: true}" nz-checkbox>SĐT
            mẹ</label></nz-form-item>
      </div>

      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.hotenngh" [ngModelOptions]="{standalone: true}" nz-checkbox>Họ tên
          người giám hộ</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.namsinhngh" [ngModelOptions]="{standalone: true}" nz-checkbox>Năm
            sinh người giám hộ</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.nghenghiepngh" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Nghề nghiệp người giám hộ</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.sdtngh" [ngModelOptions]="{standalone: true}" nz-checkbox>SĐT
          người giám hộ</label></nz-form-item>
      </div>
    </div>

    <nz-divider nzText="Thông tin khuyết tật" nzOrientation="left" nzPlain></nz-divider>

    <div nz-row [nzGutter]="[24,24]" style="padding: 10px;">
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.chungnhankt" [ngModelOptions]="{standalone: true}" nz-checkbox>Chứng
            nhận KT</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.coquancap" [ngModelOptions]="{standalone: true}" nz-checkbox>Cơ quan
            cấp</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.khanangtuphucvu" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Khả năng tự phục vụ</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.chitrahotronkt" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Chi trả hỗ trợ người khuyết tật</label></nz-form-item>
      </div>

      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.thoidiemphathiennkt" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Thời điểm phát hiện người khuyết tật</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.hieuquahotroyte" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Hiệu quả hỗ trợ y tế</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.nhucaunkt" [ngModelOptions]="{standalone: true}" nz-checkbox>Nhu cầu
          người khuyết tật</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.doclapvekinhte" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Độc lập về kinh tế</label></nz-form-item>
      </div>

      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.nguyennhan" [ngModelOptions]="{standalone: true}" nz-checkbox>Nguyên
            nhân</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.thongtinyte" [ngModelOptions]="{standalone: true}" nz-checkbox>Thông
            tin y tế</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.trinhdohocvan" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Trình độ học vấn</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.dexuatkiennghi" [ngModelOptions]="{standalone: true}" nz-checkbox>Đề
            xuất kiến nghị</label></nz-form-item>
      </div>

      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.dangkt" [ngModelOptions]="{standalone: true}" nz-checkbox>Dạng
            KT</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.nguoichamsoc" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Người chăm sóc</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.tinhtranggiaoduc" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Tình trạng giáo dục</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.hinhthuchoc" [ngModelOptions]="{standalone: true}" nz-checkbox>Hình
            thức học</label></nz-form-item>
      </div>

      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.mucdo" [ngModelOptions]="{standalone: true}" nz-checkbox>Mức
            độ</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.dieukiensong" [ngModelOptions]="{standalone: true}" nz-checkbox>Điều
            kiện sống</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.giaotiepxahoi" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Giao tiếp xã hội</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.phuongthucgiaoduc" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Phương thức GD</label></nz-form-item>
      </div>

      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.chinhsachchedobaotro" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Chính sách chế độ bảo trợ</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.thunhaphangthang" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Thu nhập hàng tháng</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.dichvuthamgia" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Dịch vụ tham gia</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.khanangnhanthuc" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Khả năng nhận thức</label></nz-form-item>
      </div>

      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.mucphucapthang" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Mức phụ cấp/tháng</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.nguonthunhapchinh" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Nguồn thu nhập chính</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.loaihinhgdthamgia" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Loại hình giáo dục tham gia</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.cacvandevehanhvi" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Các vấn đề về hành vi</label></nz-form-item>
      </div>

      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.ngaycap" [ngModelOptions]="{standalone: true}" nz-checkbox>Ngày
            cấp</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.hotrothietbidacthu" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Hỗ trợ thiết bị đặc thù</label></nz-form-item>
      </div>
      <!-- <div nz-col   [(ngModel)]="trichxuat.nhucaunkt" [ngModelOptions]="{standalone: true}" nzSpan="6"><nz-form-item><label nz-checkbox>Nhu cầu người khuyết tật</label></nz-form-item></div> -->
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.loaihinhtochuc" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Loại hình tổ chức</label></nz-form-item>
      </div>

      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.nghenghiep" [ngModelOptions]="{standalone: true}" nz-checkbox>Nghề
            nghiệp</label></nz-form-item>
      </div>
      <div nz-col nzSpan="6">
        <nz-form-item><label [(ngModel)]="trichxuat.mucdoquantamgd" [ngModelOptions]="{standalone: true}"
            nz-checkbox>Mức độ quan tâm GD</label></nz-form-item>
      </div>

      <nz-divider nzText="Quá trình học tập" nzOrientation="left" nzPlain></nz-divider>

      <div nz-row [nzGutter]="[24,24]" style="padding: 10px;">
        <div nz-col nzSpan="6">
          <nz-form-item><label [(ngModel)]="trichxuat.lophoc" [ngModelOptions]="{standalone: true}" nz-checkbox>Lớp
              học</label></nz-form-item>
        </div>
        <div nz-col nzSpan="6">
          <nz-form-item><label [(ngModel)]="trichxuat.giaovienphutrach" [ngModelOptions]="{standalone: true}"
              nz-checkbox>Giáo viên phụ trách</label></nz-form-item>
        </div>
        <div nz-col nzSpan="6">
          <nz-form-item><label [(ngModel)]="trichxuat.giaovienchunhiem" [ngModelOptions]="{standalone: true}"
              nz-checkbox>Giáo viên chủ nhiệm</label></nz-form-item>
        </div>
        <div nz-col nzSpan="6">
          <nz-form-item><label [(ngModel)]="trichxuat.ketqua" [ngModelOptions]="{standalone: true}" nz-checkbox>Kết
              quả</label></nz-form-item>
        </div>

      </div>
    </div>


  </div>
</div>
<div *nzModalFooter>
  <div class="card-footer2">
    <div class="text-left"> 
      <button nz-button (click)="CheckAll()" [disabled]="isDisabled">Chọn tất cả</button>
      <button nz-button (click)="TurnOffCheckAll()" [disabled]="isDisabled">Bỏ chọn tất cả</button>
    </div>
    <div class="text-right">
      <button nz-button (click)="exportExcel()" [disabled]="isDisabled">Xuất Excel</button>
      <button nz-button (click)="close()" [disabled]="isDisabled">Đóng</button>
    </div>
  </div>
</div>